import React from 'react';
import { IIconProps } from '../interfaces';

const AleaResidentIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '76',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.8913 49.8271V49.8288L23.8593 69.8879C28.2175 71.8083 33.0375 72.875 38.1094 72.875C43.1565 72.875 47.9542 71.8187 52.2955 69.916L52.3275 49.8271H23.8913ZM23.8913 49.8271C23.8913 48.4573 22.7781 47.3442 21.4084 47.3442M23.8913 49.8271L21.4084 47.3442M21.4084 47.3442C20.0386 47.3442 18.9255 48.4573 18.9255 49.8271M21.4084 47.3442L18.9255 49.8271M18.9255 49.8271V67.2267M18.9255 49.8271V67.2267M18.9255 67.2267C16.2607 65.5033 13.8421 63.4312 11.7344 61.0749V47.3251C11.7344 40.4299 17.3786 34.7856 24.2738 34.7856H51.9449C58.8401 34.7856 64.4844 40.4299 64.4844 47.3251V61.0749M18.9255 67.2267L64.4844 61.0749M64.4844 61.0749C62.3767 63.4312 59.9581 65.5034 57.2933 67.2267V49.8271C57.2933 48.4573 56.1801 47.3442 54.8104 47.3442C53.4412 47.3442 52.3285 48.4563 52.3275 49.8253L64.4844 61.0749Z"
      fill="white"
      stroke={color}
      strokeWidth="2.25"
    />
    <path
      d="M49.3807 19.5204C49.3807 25.7449 44.3347 30.7908 38.1103 30.7908C31.8858 30.7908 26.8398 25.7449 26.8398 19.5204C26.8398 13.2959 31.8858 8.25 38.1103 8.25C44.3347 8.25 49.3807 13.2959 49.3807 19.5204Z"
      fill="white"
      stroke={color}
      strokeWidth="2.5"
    />
  </svg>
);

export default AleaResidentIcon; 